/** [local/stage, live] */
export const ENCOFFEE_PROJECT_IDS = ['0r00ybjpr8dc9', '0rffvmenk44df'];
// '0mvm6sxazkqse'
